<template>
  <div style="color: #fff" class="rightBar">
    <v-drawer :direction="'left'" :width="'26%'">
      <div class="animated fadeInLeftBig" style="height: 100%; width: 100%">
        <div class="panel margin--bottom">
          <bar-card :bg="'border10'">
            <div class="cardContentT">
              <v-title :item="sjObj">{{ sjObj.name }}</v-title>
              <line1 class="chart" :datas="wdcgsData"></line1>
            </div>
            <div class="cardContentT">
              <v-title :item="sjObj">{{ srObj.name }}</v-title>
              <bar2 class="chart" :datas="rmsfData"></bar2>
            </div>
            <div class="cardContents">
              <v-title :item="srObj">{{ fxObj.name }}</v-title>
              <line1 class="chart" :datas="ggdata"></line1>
            </div>
          </bar-card>
        </div>
      </div>
    </v-drawer>
  </div>
</template>

<script>
import line1 from "./components/line/common/lineCommon1";
import bar2 from "./components/bar/common/barCommon4";
import { get } from "@/api/index";
export default {
  components: {
    line1,
    bar2
  },
  data() {
    return {
      sjObj: {
        name: "外地观光采购人数",
        hasBtn: true
      },
      srObj: {
        name: "热门省份观光采购人数",
        hasBtn: false
      },
      fxObj: {
        name: "本市观光采购人数",
        hasBtn: false
      },
      ggdata: [],
      wdcgsData: [],
      rmsfData: []
    };
  },
  mounted() {
    get("/api/restful/procure/cgs_num").then(res => {
      if (res instanceof Array) {
        this.wdcgsData = res.reverse().map(e => {
          return {
            date: e.date,
            price: e.num
          };
        });
      }
    });
    get("/api/restful/procure/cg_num_total").then(res => {
      if (res instanceof Array) {
        this.ggdata = res.reverse().map(e => {
          return {
            date: e.date,
            price: e.num
          };
        });
      }
    });
    get("/api/restful/procure/cgs_situation").then(res => {
      if (res instanceof Array) {
        this.rmsfData = res.map(e => {
          return {
            name: e.province,
            value: e.num
          };
        });
      }
    });
  },
  methods: {}
};
</script>

<style lang="stylus" scoped>
.cardContentT
  height 33%
  .chart
    height calc(100% - 38px)
.cardContent1
  height 33%
  position relative
  .chart
    height calc(100% - 38px)
.cardContents
  height 34%
  position relative
  .chart
    height calc(100% - 38px)
.tab-box
  position absolute
  top 40px
  right 2%
  z-index 999
  .tab-item
    color #fff
    font-size 10px
    padding-left 13px
    margin-right 20px
    position relative
    cursor pointer
    &:before
      content ' '
      width 12px
      height 12px
      border-radius 50%
      background #fff
      position absolute
      left 0
      top 50%
      transform translateY(-50%)
  .active
    color #0e9cff
    &:before
      background #0e9cff
.panel
  height calc(100% - 8px)
  width 100%
  font-size 0.06rem
  position relative

@media (max-width 1280px)
  .content
    height calc(100% - 25px)
  .cardContentT
    height 24%
    .chart
      height calc(100% - 25px)
  .cardContent1
    height 19%
    .chart
      height calc(100% - 25px)
  .cardContent
    height 30%
    .chart
      height calc(100% - 25px)
  .cardContents
    height 27%
    .chart
      height calc(100% - 25px)
</style>
